module.exports = __webpack_public_path__ + "static/media/CourseHandbook_June_2026.e7973a24.pdf";